import { render } from "./PublicDashboardItem.vue?vue&type=template&id=43992f5f"
import script from "./PublicDashboardItem.vue?vue&type=script&lang=js"
export * from "./PublicDashboardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__